<template>
  <div>
    <b-modal
      id="modal-delete"
      size="md"
      centered
      title="Perhatian .... !!!"
      header-bg-variant="danger"
      header-text-variant="light"
    >
      <p>{{ $store.state.form.delete_message }}</p>

      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-delete')">
          Batal
        </b-button>
        <b-button :disabled="busy" variant="primary" @click="execute">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "modalDelete",
  props: ["data"],
  data() {
    return {
      busy: false,
      button: "Hapus",
    };
  },
  methods: {
    execute() {
      let vm = this;
      vm.button = "Mohon Tunggu";
      vm.busy = true;
      vm.$axios
        .post("user/delete", { id: vm.data.masterUserId })
        .then((res) => {
          if (res.data.message == "sukses") {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$bvModal.hide("modal-delete");
            vm.$emit("alertFromChild", {
              variant: "success",
              showing: true,
              msg: "BERHASIL MENGHAPUS DATA",
            });
          } else {
            vm.button = "Simpan";
            vm.busy = false;
            vm.$bvModal.hide("modal-delete");
            vm.$emit("alertFromChild", {
              variant: "danger",
              showing: true,
              msg: res.data.message.toUpperCase(),
            });
          }
        })
        .catch(() => {
          vm.button = "Simpan";
          vm.busy = false;
          vm.$bvModal.hide("modal-delete");
          vm.$emit("alertFromChild", {
            variant: "danger",
            showing: true,
            msg: "TERJADI KESALAHAN PADA SERVER",
          });
        });
    },
  },
};
</script>
